import { RouteFeature } from "./feature";

export const defaultMemberRoute = RouteFeature.Dashboard;
export const defaultSiteRoute = RouteFeature.SiteBuyMembership;
export const defaultAuthenticationRoute = RouteFeature.Unauthorized;
